import React from 'react';
import { useTranslation } from '../../i18n/LanguageContext';
import { BookOpen, Home } from 'lucide-react';

const DocumentationPage = () => {
  const { t } = useTranslation();

  return (
    <div style={{
      minHeight: '100vh',
      width: '100%',
      background: 'linear-gradient(180deg, #0a0e27 0%, #1a1f3a 100%)',
      color: '#ffffff',
      fontFamily: '-apple-system, BlinkSystemFont, "SF Pro Display", sans-serif',
      padding: '120px 20px 40px',
      maxWidth: '1200px',
      margin: '0 auto'
    }}>
      <button
        onClick={() => window.location.href = '/'}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          background: 'rgba(255, 255, 255, 0.1)',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          color: '#ffffff',
          padding: '10px 16px',
          borderRadius: '12px',
          fontSize: '14px',
          fontWeight: 600,
          cursor: 'pointer',
          marginBottom: '32px'
        }}
      >
        <Home size={18} />
        Retour à l'accueil
      </button>

      <div style={{
        background: 'rgba(255, 255, 255, 0.05)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(255, 255, 255, 0.1)',
        borderRadius: '20px',
        padding: '40px',
        marginBottom: '32px'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <BookOpen size={40} color="#00d4ff" />
          <h1 style={{ fontSize: 'clamp(32px, 5vw, 48px)', fontWeight: 800, margin: 0 }}>
            Documentation
          </h1>
        </div>

        <p style={{ fontSize: '18px', color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6, marginBottom: '32px' }}>
          Bienvenue dans la documentation de WorkBiFlow. Ici vous trouverez tous les guides et ressources pour utiliser efficacement notre plateforme.
        </p>

        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
          gap: '24px',
          marginTop: '40px'
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>🚀 Guide de démarrage</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Apprenez à utiliser WorkBiFlow en quelques minutes. Découvrez comment configurer votre compte et commencer à utiliser les fonctionnalités principales.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>📱 Pointage GPS</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Découvrez comment utiliser le système de pointage avec géolocalisation GPS et reconnaissance faciale pour enregistrer vos heures de travail.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>🏖️ Gestion des congés</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Apprenez à demander des congés, consulter vos soldes et gérer vos absences depuis la plateforme.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>💰 Notes de frais</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Découvrez comment déclarer vos frais professionnels, ajouter des justificatifs et suivre le statut de vos remboursements.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>📊 Rapports et statistiques</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Apprenez à générer des rapports détaillés sur les présences, les heures travaillées et les statistiques de votre équipe.
            </p>
          </div>

          <div style={{
            background: 'rgba(255, 255, 255, 0.05)',
            border: '1px solid rgba(255, 255, 255, 0.1)',
            borderRadius: '16px',
            padding: '24px'
          }}>
            <h3 style={{ fontSize: '20px', fontWeight: 700, marginBottom: '12px' }}>⚙️ Administration</h3>
            <p style={{ color: 'rgba(255, 255, 255, 0.7)', lineHeight: 1.6 }}>
              Guide complet pour les administrateurs : gestion des employés, configuration des paramètres, et bien plus encore.
            </p>
          </div>
        </div>

        <div style={{
          marginTop: '48px',
          padding: '32px',
          background: 'rgba(0, 212, 255, 0.1)',
          border: '1px solid rgba(0, 212, 255, 0.3)',
          borderRadius: '16px',
          textAlign: 'center'
        }}>
          <h3 style={{ fontSize: '24px', fontWeight: 700, marginBottom: '16px' }}>
            Besoin d'aide supplémentaire ?
          </h3>
          <p style={{ color: 'rgba(255, 255, 255, 0.8)', marginBottom: '24px' }}>
            Notre équipe de support est disponible 24/7 pour répondre à vos questions.
          </p>
          <button
            onClick={() => window.location.href = '/contact'}
            style={{
              background: 'linear-gradient(135deg, #00d4ff, #00a8cc)',
              color: '#ffffff',
              border: 'none',
              padding: '12px 24px',
              borderRadius: '12px',
              fontSize: '16px',
              fontWeight: 600,
              cursor: 'pointer'
            }}
          >
            Contacter le support
          </button>
        </div>
      </div>
    </div>
  );
};

export default DocumentationPage;

